import { useState, useEffect } from 'react';
import api from '../../api';
import stili from './stili';

const MESI = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];

// Parametri del periodo scelto nella pagina: un mese, oppure tutto l'anno con "Tutte le pratiche dell'anno"
export const periodoStampa = (mese, tuttiMesi) => (tuttiMesi ? { anno: mese.slice(0, 4) } : { mese });
const descriviPeriodo = (mese, tuttiMesi) => (tuttiMesi ? `anno ${mese.slice(0, 4)}` : `${MESI[Number(mese.slice(5, 7)) - 1]} ${mese.slice(0, 4)}`);

// "Stampa per parcellazione": si sceglie il fatturante (di default "Tutti i fatturanti": una sezione per ciascuno) e si stampa
// il periodo scelto nella pagina (mese, oppure l'intero anno), in PDF o Excel.
export default function StampaParcellazione({ fatturanti, mese, tuttiMesi = false, onChiudi }) {
  const [fatturante, setFatturante] = useState('tutti');
  const [righe, setRighe] = useState(null);   // numero di righe che verranno stampate
  const [errore, setErrore] = useState('');
  const [inCorso, setInCorso] = useState('');
  const periodo = periodoStampa(mese, tuttiMesi);

  useEffect(() => {
    setRighe(null);
    let annullato = false;
    api.get('/competenze', { params: { ...periodo, ...(fatturante === 'tutti' ? {} : { fatturante_id: fatturante }) } })
      .then(r => { if (!annullato) setRighe(r.data.totale ?? r.data.competenze.length); })
      .catch(() => { if (!annullato) setRighe(null); });
    return () => { annullato = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fatturante, mese, tuttiMesi]);

  const scarica = async (formato) => {
    setErrore('');
    setInCorso(formato);
    try {
      const res = await api.get('/competenze/stampa-parcellazione', { params: { fatturante_id: fatturante, ...periodo, formato }, responseType: 'blob' });
      const nome = (res.headers['content-disposition'] || '').match(/filename=([^;]+)/)?.[1] || `parcellazione_${mese}.${formato === 'excel' ? 'xlsx' : 'pdf'}`;
      const link = document.createElement('a');
      link.href = URL.createObjectURL(res.data);
      link.download = nome;
      link.click();
      setTimeout(() => URL.revokeObjectURL(link.href), 1000);
    } catch (err) {
      let testo = 'Stampa non riuscita';
      try { testo = JSON.parse(await err.response.data.text()).errore || testo; } catch { /* messaggio generico */ }
      setErrore(testo);
    } finally { setInCorso(''); }
  };

  const vuoto = righe === 0;
  const nome = fatturante === 'tutti' ? 'tutti i fatturanti' : fatturante === 'nessuno' ? 'Senza fatturante' : fatturanti.find(f => String(f.id) === fatturante)?.nome;
  const bloccato = vuoto || Boolean(inCorso);

  return (
    <div style={stili.overlay} role="dialog" aria-label="Stampa per parcellazione">
      <div style={{ ...stili.modal, maxWidth: '460px' }}>
        <h3 style={{ marginTop: 0 }}>Stampa per parcellazione</h3>
        <p style={{ color: '#555', fontSize: '0.88rem', marginTop: 0 }}>Stampa il periodo scelto nella pagina: <strong>{descriviPeriodo(mese, tuttiMesi)}</strong>. Con "Tutti i fatturanti" la stampa è divisa per fatturante, una sezione ciascuno.</p>
        <label style={stili.label} htmlFor="parcellazione-fatturante">Fatturante</label>
        <select id="parcellazione-fatturante" value={fatturante} onChange={e => setFatturante(e.target.value)} style={stili.input}>
          <option value="tutti">Tutti i fatturanti</option>
          {fatturanti.map(f => <option key={f.id} value={f.id}>{f.nome}{f.attivo ? '' : ' (non attivo)'}</option>)}
          <option value="nessuno">Senza fatturante</option>
        </select>
        {righe !== null && (
          <p style={{ fontSize: '0.88rem', color: vuoto ? '#b91c1c' : '#166534', marginBottom: 0 }}>
            {vuoto ? `Nessuna riga per ${nome} in questo periodo: niente da stampare.` : `${righe} ${righe === 1 ? 'riga' : 'righe'} per ${nome}.`}
          </p>
        )}
        {errore && <div style={{ ...stili.errore, marginTop: '0.8rem' }}>{errore}</div>}
        <div style={stili.azioni}>
          <button type="button" onClick={onChiudi} style={stili.btnSecondary}>Chiudi</button>
          <button type="button" onClick={() => scarica('excel')} disabled={bloccato} style={{ ...stili.btnSecondary, opacity: vuoto ? 0.45 : 1 }}>{inCorso === 'excel' ? 'Preparazione…' : 'Scarica Excel'}</button>
          <button type="button" onClick={() => scarica('pdf')} disabled={bloccato} style={{ ...stili.btn, opacity: vuoto ? 0.45 : 1 }}>{inCorso === 'pdf' ? 'Preparazione…' : 'Scarica PDF'}</button>
        </div>
      </div>
    </div>
  );
}
